































































































































import { Component, Mixins } from 'vue-mixin-decorator';
import { Prop } from 'vue-property-decorator';
import Dialog from '@/components/Dialog.vue';
import { DownloadFileMixin } from '@/mixins/DownloadFileMixin';
import Http from '@/Http';
import { Getter } from 'vuex-class';
import { Provider, Town } from '@/types/work/invoice';
import { Position } from '@/types/work/enterprise';
import { GET_POSITIONS } from '@/store/models/work/enterprise/positions';
import SelectCustomer from '@/components/work/customers/SelectCustomer.vue';
import FtCombobox from '@/components/ft/combobox.vue';

@Component({
  components: { SelectCustomer, Dialog, FtCombobox }
})
export default class InvoiceReport extends Mixins<DownloadFileMixin>(DownloadFileMixin) {
  @Prop() showDialog: boolean = false;
  @Getter(GET_POSITIONS) posts!:Position[];

  public getUserName (user:any) {
    if (user.user_name) {
      return user.user_last_name + ' ' + user.user_name;
    }
    return user.last_name || '' + ' ' + user.name || '';
  }

  public getUsers ():Position[] {
    let users:Position[] = [];
    if (this.posts) {
      this.posts.forEach(function (p:Position) {
        if (p.user_id) {
          users.push(p);
        }
      });
    }
    return users;
  }

  protected filterDate = {
    field: 'created_at',
    from: '',
    to: ''
  };
  protected filters = {
    user_id: undefined,
    provider_id: undefined,
    all_user_customers: 0,
    products_received: undefined,
    comment: '',
    field_in: {
      field: 'id',
      values: []
    }
  };

  loading = false;
  public to = false;
  public from = false;

  public generateReport () {
    this.loading = true;
    (new Http()).arrayBuffer({
      url: `enterprise/${this.$route.params.enterprise}/invoices/reports`,
      params: {
        filters: {
          per_date: [{ ...this.filterDate }],
          ...this.filters
        } }
    })
      .then((response:any) => {
        this.downloadFile(response);
        this.loading = false;
        this.$emit('close');
      })
      .catch((e:any) => {
        this.loading = false;
      });
  }

  public getProviderAddress (item:Provider) {
    let address = '';
    if (item.data.enterprise) {
      address = item.data.enterprise.street + ' ' + item.data.enterprise.building;
    } else address = item.address;
    return this.getProviderTown(item.town) + ' ' + address;
  }

  public getProviderTown (town?:Town) {
    return town ? (town.district ? town.district + ' район, ' : '') + town.title : '';
  }
}
